import { Outlet, Route, RouterProvider, createRoutesFromElements, useNavigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
// 'react-router-dom' の代わりに '@datadog/browser-rum-react/react-router-v6' の "createBrowserRouter" を使用する
// https://github.com/DataDog/browser-sdk/tree/main/packages/rum-react#react-router-integration
// https://github.com/DataDog/browser-sdk/blob/6b3cfefd90ecb05a45b840f3447c4882b1811eba/packages/rum-react/src/domain/reactRouterV6/createRouter.ts
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import { layout } from '../styled-system/recipes';
import { GlobalHeader } from '#/components/GlobalHeader';
import { GlobalFooter } from '#/components/GlobalFooter';
import { MyPage } from '#/pages/MyPage';
import { EmailChangePage } from '#/pages/EmailChangePage';
// https://github.com/dw-zenid/zenid/issues/406
// 暫定対応のためZEN ID側のプライバシーポリシー画面はコメントアウト
// import { PrivacyPolicy } from '#/pages/PrivacyPolicy';
import { Terms } from '#/pages/Terms';
import { NoMatch } from '#/pages/NoMatch/NoMatch';
import { GenericError } from '#/components/Error/GenericError';
import { Login } from '#/pages/Login';
import { AuthProvider } from '#/utils/auth/AuthProvider';
import { auth0Client } from '#/utils/auth/auth0Client';

function AppLayout({ children }: { children: ReactNode }) {
  const { zenidContainer, mainContentsContainer, mainContentsInnerContainer, errorContainer } = layout();
  const navigate = useNavigate();
  return (
    <AuthProvider client={auth0Client} onRedirectCallback={() => navigate(window.location.pathname)}>
      <div
        className={zenidContainer}
        style={{ backgroundImage: `url(${import.meta.env.VITE_ASSETS_URL}/assets/images/zenid_bg.png)` }}
      >
        <GlobalHeader />
        <div className={mainContentsContainer}>
          <div className={mainContentsInnerContainer}>
            <ErrorBoundary
              fallback={
                <div className={errorContainer}>
                  <GenericError />
                </div>
              }
            >
              {children}
            </ErrorBoundary>
          </div>
        </div>
        <GlobalFooter />
      </div>
    </AuthProvider>
  );
}

/**
 * アプリ全体のルーティング情報を管理する
 */
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <AppLayout>
          <Outlet />
        </AppLayout>
      }
    >
      <Route path="login" element={<Login />} />
      <Route path="home" element={<MyPage />} />
      <Route path="edit/email" element={<EmailChangePage />} />
      <Route path="/terms">
        {/* https://github.com/dw-zenid/zenid/issues/406
      暫定対応のためZEN ID側のプライバシーポリシー画面はコメントアウト */}
        {/* <Route path="privacy" element={<PrivacyPolicy />} /> */}
        <Route index element={<Terms />} />
      </Route>
      <Route path="*" element={<NoMatch />}></Route>
    </Route>
  )
);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
